'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isLastMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isLastMonth.js
// module id = 307
// module chunks = 0